import { Translations } from "models/Translations";

export class Translate {
    static text(translations: Translations, text: string) {
        let obj = translations.entries.find(l => Object.keys(l)[0] === text);
        if (obj) {
            return obj[text] as string;
        } else { // try again without beeing case sensitive
            obj = translations.entries.find(l => Object.keys(l)[0].toUpperCase() === text.toUpperCase());
            if (obj) {
                return obj[Object.keys(obj)[0]] as string;
            }
        }
        return text;
    }
}